import $ from 'jquery';

const windowLocation = encodeURIComponent(window.location.href);
const defaultPopupSettings = 'menubar=no, toolbar=no, resizable=yes, scrollbars=yes';

const dimensions = () => {
  const aw = window.screen.availWidth;
  const ah = window.screen.availHeight;
  const w = aw > 600 ? 600 : aw;
  const h = ah > 600 ? 600 : ah;
  const l = (window.screen.availLeft + (aw / 2)) - (w / 2);
  const t = (window.screen.availTop + (ah / 2)) - (h / 2);
  return `height=${h}, width=${w}, top=${t}, left=${l}`;
};

const share = (url) => {
  window.open(`${url}${windowLocation}`, '', `${defaultPopupSettings}, ${dimensions()}`);
};

const shareFacebook = (e) => {
  e.preventDefault();
  share('https://www.facebook.com/sharer/sharer.php?u=');
};

const shareTwitter = (e) => {
  e.preventDefault();
  share('https://twitter.com/share?url=');
};

const shareGooglePlus = (e) => {
  e.preventDefault();
  share('https://plus.google.com/share?url=');
};

const shareType = (button) => {
  const $button = $(button);
  if ($button.hasClass('js-share-facebook')) {
    return shareFacebook;
  } else if ($button.hasClass('js-share-twitter')) {
    return shareTwitter;
  } else if ($button.hasClass('js-share-googleplus')) {
    return shareGooglePlus;
  }
  return (e) => { e.preventDefault(); };
};

const shareButtonFactory = (shareButtons) => {
  Array.from(shareButtons).forEach(button => {
    button.addEventListener('click', shareType(button));
  });
};

$(document).ready(() => {
  shareButtonFactory(document.querySelectorAll('[class*=js-share]'));
});
